__turbopack_context__.v({
  "default": "TextLink-module__b8wWeW__default",
  "largerClickArea": "TextLink-module__b8wWeW__largerClickArea",
  "link": "TextLink-module__b8wWeW__link",
  "onColor": "TextLink-module__b8wWeW__onColor",
  "secondary": "TextLink-module__b8wWeW__secondary",
  "small": "TextLink-module__b8wWeW__small",
  "textColor": "TextLink-module__b8wWeW__textColor",
});
